import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from "react-icons/io";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
const getOrderStatus = (ordersTally) => {
  if (ordersTally?.status === "accepted") {
    return <span class="badge bg-green text-green-fg">ACCEPTED</span>;
  }
  return <span class="badge bg-red text-red-fg">PENDING</span>;
};
const getOrderFromOrTo = (item) => {
  if (item?.orderType.endsWith("to cnf")) {
    return item?.user_model?.userName || "N/A";
  }
  if (!item.orderTo) {
    return "NA";
  }
  if (item.orderTo === 1) {
    return "Kryzen";
  }
  if (item.orderTo === 2) {
    return "Kryzen CNF";
  } else {
    return item?.OrderToUser?.userName;
  }
};

const getArrowByOderType = (item, ordersTallyOf) => {
  if (ordersTallyOf === "Kryzen-CNF") {
    if (item?.orderType?.endsWith("to cnf")) {
      return (
        <IoIosArrowRoundDown className="me-2 fs-2" style={{ color: "green" }} />
      );
    } else {
      return (
        <IoIosArrowRoundUp className="me-2 fs-2" style={{ color: "red" }} />
      );
    }
  } else if (ordersTallyOf === "Kryzen") {
    if (item?.orderType?.endsWith("to kryzen")) {
      return (
        <IoIosArrowRoundDown className="me-2 fs-2" style={{ color: "green" }} />
      );
    } else {
      return (
        <IoIosArrowRoundUp className="me-2 fs-2" style={{ color: "red" }} />
      );
    }
  } else if (ordersTallyOf === "Farmers") {
    if (item?.orderType?.endsWith("to farmer")) {
      return (
        <IoIosArrowRoundDown className="me-2 fs-2" style={{ color: "green" }} />
      );
    } else {
      return (
        <IoIosArrowRoundUp className="me-2 fs-2" style={{ color: "red" }} />
      );
    }
  }
};

const OrdersTallyTable = ({
  ordersTallyOf,
  ordersTally,
  currentPage,
  itemsPerPage,
}) => {
  const tableHead = ["Sr.", "Order Id", "credit", "debits", "balance"];
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/farm-cnf-order/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {ordersTally?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{item?.id}</td>
                <td>
                  {getArrowByOderType(item, ordersTallyOf)}
                  <b>{item?.orderID || "N/A"}</b>
                </td>

                <td className="text-success">
                  {item?.credit ? roundOffCost(item?.credit) : "---"}
                </td>
                <td className="text-danger">
                  {item?.debit ? roundOffCost(item?.debit) : "---"}
                </td>
                <td
                  className={item?.balance > 0 ? "text-success" : "text-danger"}
                >
                  {item?.balance ? roundOffCost(item?.balance) : "---"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default OrdersTallyTable;
